module.exports = __webpack_public_path__ + "img/32.16195f89.jpg";